import React from 'react';
import { observer } from 'mobx-react-lite';

import { ShopDropdown } from './shop-dropdown';
import { useShopDropdown } from './use-shop-dropdown';

type ControllerProps = {
  anchorEl?: HTMLElement;
};

export const ShopDropdownController = observer(({ anchorEl }: ControllerProps): JSX.Element | null => {
  const { showShopMenu, categoryLinks, isCategoryLinksLoading, toggleShopMenu } = useShopDropdown();

  if (isCategoryLinksLoading) {
    return null;
  }

  return (
    <ShopDropdown anchorEl={anchorEl} categories={categoryLinks} open={showShopMenu} toggleShopMenu={toggleShopMenu} />
  );
});
